export function pickupDayLabel(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Riga', weekday: 'short', hour: '2-digit', hourCycle: 'h23'
  }).formatToParts(now);
  const value = type => parts.find(part => part.type === type)?.value;
  const weekday = value('weekday');
  return !['Sat', 'Sun'].includes(weekday) && Number(value('hour')) < 18 ? 'today' : 'next';
}
if (typeof customElements !== 'undefined' && !customElements.get('defset-pickup-time')) {
  customElements.define('defset-pickup-time', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const label = this.querySelector('[data-pickup-day]');
        if (label) label.textContent = pickupDayLabel() === 'today' ? this.dataset.today : this.dataset.next;
      };
      this.update();
      this.timer = setInterval(this.update, 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
